import { Pipe, PipeTransform } from '@angular/core';
import { LicenseType } from '@shared/model/license-type.enum';

@Pipe({
	name: 'planIcon',
})
export class PlanIconPipe implements PipeTransform {
	transform(licenseType: LicenseType): string {
		switch (licenseType) {
			case LicenseType.FARMER:
				return 'sf-farmer';
			case LicenseType.NUTRITION_SPECIALIST:
				return 'sf-nutrition';
			case LicenseType.CUSTOM:
				return 'sf-custom-plan';
			default:
				return 'sf-free';
		}
	}
}
